import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React, { useContext } from 'react';
import { Text } from 'react-aria-components';
import { CustomStateContext } from '../select/aria/select.esm.js';
import { PrivateText } from '../text/text.esm.js';

var _excluded = ["className"];
function Description(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useContext(CustomStateContext) || {},
    hasError = _ref2.hasError;
  return /*#__PURE__*/React.createElement(PrivateText, _extends({
    className: cn(className, {
      hidden: hasError
    }),
    anchorClassName: "csg-tw-description"
    // @ts-ignore
    ,
    as: Text
  }, props, {
    slot: "description",
    size: "0.75"
  }));
}

export { Description as default };
//# sourceMappingURL=description.esm.js.map
